"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";

export function MetaPixel() {
	const pathname = usePathname();

	useEffect(() => {
		if (typeof window !== "undefined" && window.fbq) {
			window.fbq("track", "PageView");
		}
	}, [pathname]);

	return null;
}
